<template>
  <div>
    <div class="modal hide fade" id="modalWorkshopList" tabindex="-1" role="dialog" aria-labelledby="modalWorkshopList" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Workshop List</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <div class="form-inline ml-auto">
                <div class="button-group">
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="selectWorkshop" data-dismiss="modal">Process</button>
                  <button type="button" class="btn btn-sm btn-soft-primary" @click="refreshList">
                  <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                  </button>
                  rows:
                  <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                  <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                  </select>
                  <span class="mr-1">
                  Total rows: <b>{{ rowsTotal }}</b>
                  </span>
                  <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                </div>
                <div class="form-group mx-sm-3 mb-2">
                    <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery"/>
                </div>
                <span class="mr-1">
                    page:
                    <select v-model="currentPage">
                    <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                    </select>
                    / {{ pageLength }}
                </span>
                <nav aria-label="Page navigation example" class="pull-right">
                    <ul class="pagination">
                    <li class="page-item">
                        <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="prevPage">
                        <i class="fa fa-angle-left" aria-hidden="true"></i>
                        </a>
                    </li>
                    <li class="page-item">
                        <a class="btn btn-default btn-sm" href="javascript:void(0)" @click="nextPage">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                        </a>
                    </li>
                    </ul>
                </nav>
              </div>
              <table class="table table-sm table-item table-hover table-striped">
                <thead>
                    <th>
                        <label class="form-checkbox"><input type="checkbox" v-model="selectAll" @click="selectList"><i class="form-icon"></i></label>
                    </th>
                    <th>Status</th>
                    <th>Workshop No.</th>
                    <th>Customer</th>
                    <th>Mechanic</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th>Schedule</th>
                    <th>Start</th>
                    <th>End</th>
                    <th>Work Hour</th>
                </thead>
                <tbody>
                    <tr v-if="filterData.length < 1">
                        <td colspan="11" style="text-align: center"><i>No Data</i></td>
                    </tr>
                    <tr v-for="u in filterData" v-bind:key="u.id">
                        <td><label class="form-checkbox"><input type="checkbox" :value="u.id" v-model="selected" /><i class="form-icon"></i></label></td>
                        <td>
                            <span class="badge badge-info" v-if="u.status === 'open'">{{ u.status }}</span>
                            <span class="badge badge-warning" v-else-if="u.status === 'on progress'">{{ u.status }}</span>
                            <span class="badge badge-success" v-else-if="u.status === 'finish'">{{ u.status }}</span>
                            <span class="badge badge-danger" v-else-if="u.status === 'void'">{{ u.status }}</span>
                            <span class="badge badge-second" v-else>{{ u.status }}</span>
                        </td>
                        <td><b>{{ u.workshop_no }}</b></td>
                        <td><b>{{ u.customer.name }}</b></td>
                        <td>{{ u.mechanic }}</td>
                        <td>{{ u.workshop_type.name }}</td>
                        <td>{{ u.date_in | dateFormat('DD/MM/YYYY') }}</td>
                        <td>{{ u.schedule_date | dateFormat('DD/MM/YYYY')}}</td>
                        <td>{{ u.work_start | dateFormat('DD/MM/YYYY H:m:s') }}</td>
                        <td>{{ u.work_finish | dateFormat('DD/MM/YYYY H:m:s') }}</td>
                        <td>{{ u.hours }}</td>
                    </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'
export default {
  name: 'WorkshopListModal',
  components: {
    DatePicker
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      workshopList: state => state.workshops.workshopList
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.workshopList.length
      } else {
        count = this.workshopList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.workshopList.length
      } else {
        count = this.workshopList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.workshopList.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter((d) => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  props: ['date'],
  data () {
    // var date = new Date(this.date)
    // console.log(this.date + ' > ' + date)
    // var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    // console.log(date1 + ' || ' + date2)
    return {
      startDate: [],
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status'
      }, {
        name: 'Workshop Number',
        prop: 'workshop_no'
      }, {
        name: 'Customer',
        prop: 'customer.name'
      }, {
        name: 'Mechanic',
        prop: 'mechanic'
      }, {
        name: 'Service Type',
        prop: 'type_id'
      }, {
        name: 'Date',
        prop: 'date_in'
      }, {
        name: 'Schedule',
        prop: 'schedule_date'
      }, {
        name: 'Start',
        prop: 'work_start'
      }, {
        name: 'Finish',
        prop: 'work_finish'
      }, {
        name: 'Work Hours',
        prop: 'hours'
      }],
      selectAll: false,
      selected: [],
      statusCheck: [],
      typeCheck: []
    }
  },
  methods: {
    selectWorkshop () {
      this.$emit('selectWorkshop', this.selected)
      this.selectAll = false
      this.selected = []
    },
    refreshList () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = {
        begin: begin,
        end: end,
        company: null
      }
      console.log(payload)
      this.$store.dispatch('getWorkshopList', payload)
    },
    selectList: function () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if (this.currentPage * this.pageSize < this.filterData.length) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    }
  }
}
</script>
